import {observer} from 'mobx-react';
import {Nav, NavBody, NavList, NavToggle} from '../../styles/nav';
import AppStore from "../../app.store";
import {Layout} from '../../styles/layout';
import {
    headerSize,
    primaryColor,
    brandWordmarkColor,
    sidebarBackground,
    shellDivider,
    fontFamily,
} from '../../utils/variables';
import { VisorEmblemLogo } from '../visor-emblem-logo';
import ArrowIcon from '../../assets/icons/caret-right.svg';
import styled from 'styled-components';
import BurgerView from "./burger.view";
import {RenderNavItems} from "./navbar.list";
import {Image} from '../../styles/image';

/** Как на лендинге: flex items-center space-x-2 + h-[32px] logo + text-xl wordmark */
const NavbarBrand = styled.div<{ $expanded?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ $expanded }) => ($expanded ? '8px' : '0')};
  padding: 0 ${({ $expanded }) => ($expanded ? '12px' : '4px')};
  width: 100%;
  min-width: 0;
  border-bottom: 1px solid ${shellDivider};
  height: 100%;
  min-height: ${headerSize}px;
  flex-shrink: 0;
  user-select: none;
  cursor: default;
`;

const BrandLogoMark = styled(VisorEmblemLogo)<{ $expanded?: boolean }>`
  width: auto;
  height: ${({ $expanded }) => ($expanded ? '32px' : '24px')};
  flex-shrink: 0;
  display: block;
  color: ${primaryColor};
`;

/** landing: text-xl font-semibold text-blue-600 tracking-wider */
const BrandWordmark = styled.span`
  font-family: ${fontFamily};
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  color: ${brandWordmarkColor};
  white-space: nowrap;
  -webkit-font-smoothing: antialiased;
  user-select: none;
  cursor: default;
`;

const Navbar = observer(() => {
    const {
        isNavOpen,
        toggleIssNavOpen,
        isMacOS
    } = AppStore;

    return (
        <>
            <Nav expanded={isNavOpen} isMacOs={isMacOS} id={'navbar'}>
                <Layout
                    centered
                    heightSize={headerSize}
                    background={sidebarBackground}
                    id={'navbar-logo-div'}
                    padding="0"
                >
                    <NavbarBrand $expanded={isNavOpen} id={'navbar-logo'}>
                        <BrandLogoMark $expanded={isNavOpen} aria-hidden />
                        {isNavOpen && <BrandWordmark>VISOR</BrandWordmark>}
                    </NavbarBrand>
                </Layout>
                <NavBody isMacOs={isMacOS}>
                    <NavList id={'navbar-list'}>
                        <RenderNavItems setOpen={() => false} />
                    </NavList>
                </NavBody>
                <NavToggle
                    id={'navbar-arrow'}
                    type="button"
                    expanded={isNavOpen}
                    onClick={toggleIssNavOpen}
                    aria-label={isNavOpen ? 'Свернуть меню' : 'Развернуть меню'}
                >
                    <Image src={ArrowIcon} height="18px" extent="18px" alt="" />
                </NavToggle>
            </Nav>
            <BurgerView/>
        </>
    );
});

export default Navbar;
